import { useQuery } from "@tanstack/vue-query";
import PermissionService, { type RolePermissionsResponse } from "@/services/permission-service";

export function useRolePermissions() {
  return useQuery<RolePermissionsResponse>({
    queryKey: ["role-permissions"],
    queryFn: async () => {
      const result = await PermissionService.getRolePermissions();
      if (result.data?.status) {
        return result.data.data;
      }
      throw new Error(result.data?.msg || "Failed to load role permissions");
    },
    staleTime: 5 * 60 * 1000,
    gcTime: 10 * 60 * 1000,
  });
}
